module.exports = __webpack_public_path__ + "static/img/CodySimpson.88db88d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CodySimpson.jpg
// module id = SeCa
// module chunks = 0